import { TimeLogApi, ToastStateHandler } from '../../../api';
import { ICallback } from '../../../commonTypes/hook.types';
import { TimeLogCreateDto } from '../../../commonTypes/timelog.types';
import { useContainer } from '../../useContainer';
import { useTranslation } from '../../useTranslation';

const useHttpPostTimeLog = () => {
    const timeLogApi: TimeLogApi = useContainer(TimeLogApi);
    const toastHandler = useContainer(ToastStateHandler);
    const { t } = useTranslation('newNotifications');

    const exec = (body: TimeLogCreateDto, callback: ICallback) => {
        const { exec, abort } = timeLogApi.create({
            body,
            onSuccess: res => {
                toastHandler.push('success', t('timelog.createTimelogTitle'), t('timelog.createTimelogSuccess'));
                if (callback.onSuccess) callback.onSuccess(res.body);
            },
            onError: error => {
                toastHandler.push('error', t('timelog.createTimelogTitle'), t('timelog.createTimelogError'));
                if (callback.onError) callback.onError(error);
            },
        });
        exec();
        return abort;
    };

    return { exec };
};

export default useHttpPostTimeLog;
